/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Score_GradeInputs */

const en_resume_editor_score_grade = /** @type {(inputs: Resume_Editor_Score_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score/Grade`)
};

const de_resume_editor_score_grade = /** @type {(inputs: Resume_Editor_Score_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

const fr_resume_editor_score_grade = /** @type {(inputs: Resume_Editor_Score_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score/Note`)
};

const es_resume_editor_score_grade = /** @type {(inputs: Resume_Editor_Score_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuacion/Calificacion`)
};

const it_resume_editor_score_grade = /** @type {(inputs: Resume_Editor_Score_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punteggio/Voto`)
};

const nl_resume_editor_score_grade = /** @type {(inputs: Resume_Editor_Score_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score/Cijfer`)
};

const pl_resume_editor_score_grade = /** @type {(inputs: Resume_Editor_Score_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wynik/Ocena`)
};

const fi_resume_editor_score_grade = /** @type {(inputs: Resume_Editor_Score_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pistemäärä/Arvosana`)
};

const da_resume_editor_score_grade = /** @type {(inputs: Resume_Editor_Score_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score/Karakter`)
};

const sv_resume_editor_score_grade = /** @type {(inputs: Resume_Editor_Score_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betyg/Omdome`)
};

/**
* | output |
* | --- |
* | "Score/Grade" |
*
* @param {Resume_Editor_Score_GradeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_score_grade = /** @type {((inputs?: Resume_Editor_Score_GradeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Score_GradeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_score_grade(inputs)
	if (locale === "fr") return fr_resume_editor_score_grade(inputs)
	if (locale === "es") return es_resume_editor_score_grade(inputs)
	if (locale === "it") return it_resume_editor_score_grade(inputs)
	if (locale === "nl") return nl_resume_editor_score_grade(inputs)
	if (locale === "pl") return pl_resume_editor_score_grade(inputs)
	if (locale === "fi") return fi_resume_editor_score_grade(inputs)
	if (locale === "da") return da_resume_editor_score_grade(inputs)
	if (locale === "sv") return sv_resume_editor_score_grade(inputs)
	return en_resume_editor_score_grade(inputs)
});